import { Github, Check, GitBranch } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface RepoConnectedData {
  repo_full_name: string;
  default_branch: string;
}

interface GitHubRepoConnectedWidgetProps {
  data: RepoConnectedData;
}

export function GitHubRepoConnectedWidget({ data }: GitHubRepoConnectedWidgetProps) {
  return (
    <Card variant="success" padding="none" className="overflow-hidden max-w-md animate-slide-up">
      <div className="flex items-center gap-3 px-4 py-3">
        <div className="flex items-center justify-center h-8 w-8 rounded-lg bg-daydra-success/10">
          <Github size={16} className="text-daydra-success" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-daydra-text">Repository connected</p>
          <div className="flex items-center gap-2 mt-0.5">
            <span className="font-mono text-xs text-daydra-dim truncate">
              {data.repo_full_name}
            </span>
            <Badge variant="default" size="sm">
              <GitBranch size={10} className="mr-0.5" />
              {data.default_branch}
            </Badge>
          </div>
        </div>
        <Check size={18} className="text-daydra-success shrink-0" />
      </div>
    </Card>
  );
}
